module.exports = __webpack_public_path__ + "img/picture.091de1f6.jpg";